/* assets/rc-arrow-keys.js: the left and right arrow keys move the carousel you are looking at on a product page.
   Loaded by sections/section-bundle-pdp.liquid (every product page built on it).

   Which carousel: the one holding keyboard focus, else the one under the mouse, else the one taking up the most of
   the screen (the photo gallery at the top of the page). Each key press clicks that carousel's own previous or next
   arrow, so it moves exactly as a click does (a photo, a screen of cards, the ends stop or wrap as the arrow does).

   Left alone, so nothing answers twice or steals a key:
   - a full-screen viewer, drawer or the search panel is open (the photo zoom and the clip player already take the
     arrows themselves), seen as a scroll lock on html or body, an open bag, an open dialog;
   - typing in a field, choosing in a select, radio, slider, tab or menu, or on a carousel's own scroll bar;
   - any key with Alt, Ctrl, Cmd or Shift, and up and down (those still scroll the page). */
(function () {
  'use strict';
  if (window.RC_ARROW_KEYS) return;
  window.RC_ARROW_KEYS = true;
  var D = document, W = window;

  /* each row's previous and next arrows, in the order a section is checked; the first pair that is on screen wins
     (a row whose nav is hidden does not scroll, so it is skipped) */
  var PAIRS = [
    ['[data-rcx-step="-1"]', '[data-rcx-step="1"]'],     /* shared rail: recently viewed, pairs well (assets/rc-card.js) */
    ['[data-rcpr-step="-1"]', '[data-rcpr-step="1"]'],   /* product rows: more designs, build out your kit */
    ['[data-rcr-step="-1"]', '[data-rcr-step="1"]'],     /* detail reel: what you're actually getting */
    ['[data-rcu-go="-1"]', '[data-rcu-go="1"]'],         /* runners' clips row (not its player, which has its own keys) */
    ['[data-wfpr-go="-1"]', '[data-wfpr-go="1"]'],       /* reviews, desktop chevrons */
    ['[data-wfpr-prev]', '[data-wfpr-next]'],            /* reviews, the other arrows */
    ['[data-recent-go="-1"]', '[data-recent-go="1"]'],   /* older recently viewed */
    ['[data-recent-prev]', '[data-recent-next]']
  ];
  var SKIP_ROLES = /^(slider|scrollbar|spinbutton|tab|tablist|radio|radiogroup|listbox|option|menu|menuitem|menubar|combobox|textbox|grid|tree)$/;

  function shown(el) {
    if (!el || !el.getClientRects().length) return false;
    var cs = W.getComputedStyle(el);
    return cs.visibility !== 'hidden' && parseFloat(cs.opacity) > 0.05;
  }
  function blocked() {
    var h = D.documentElement, b = D.body;
    if (W.getComputedStyle(h).overflowY === 'hidden' || (b && W.getComputedStyle(b).overflowY === 'hidden')) return true;
    if (h.classList.contains('rcs-open') || D.querySelector('#rcCartDevRoot.isOpen, dialog[open]')) return true;
    var m = D.querySelectorAll('[aria-modal="true"]');
    for (var i = 0; i < m.length; i++) { if (shown(m[i])) return true; }
    var lb = D.getElementById('bp-lightbox');
    return !!(lb && !lb.hidden);
  }
  function typing(t) {
    if (!t || t === D.body || !t.closest) return false;
    if (t.closest('input, textarea, select, [contenteditable=""], [contenteditable="true"]')) return true;
    var r = t.getAttribute('role');
    return !!(r && SKIP_ROLES.test(r));
  }

  /* the carousels on the page right now: { areas: elements that count as "this carousel", prev, next } */
  function rows() {
    var out = [];
    var hero = D.getElementById('bp-hero'), hp = D.getElementById('bp-hero-prev'), hn = D.getElementById('bp-hero-next');
    if (hero && hp && hn && hero.querySelectorAll('.bp-hero__slide').length > 1) {
      out.push({ areas: [hero, D.getElementById('bp-thumbs')].filter(Boolean), prev: hp, next: hn });
    }
    var secs = D.querySelectorAll('.shopify-section');
    for (var i = 0; i < secs.length; i++) {
      var s = secs[i];
      if (hero && s.contains(hero)) continue;
      for (var k = 0; k < PAIRS.length; k++) {
        var p = s.querySelector(PAIRS[k][0]), n = s.querySelector(PAIRS[k][1]);
        if (p && n && shown(p) && shown(n)) { out.push({ areas: [s], prev: p, next: n }); break; }
      }
    }
    return out;
  }
  function inRow(row, el) {
    for (var i = 0; i < row.areas.length; i++) { if (row.areas[i].contains(el)) return true; }
    return false;
  }
  /* how much of the row is on screen, in pixels of height */
  function onScreen(row) {
    var best = 0, vh = W.innerHeight;
    for (var i = 0; i < row.areas.length; i++) {
      var r = row.areas[i].getBoundingClientRect();
      if (r.width <= 0) continue;
      best = Math.max(best, Math.min(r.bottom, vh) - Math.max(r.top, 0));
    }
    return best;
  }

  var hovered = null;
  D.addEventListener('pointerover', function (e) { if (e.pointerType === 'mouse') hovered = e.target; }, { passive: true });
  D.addEventListener('mouseout', function (e) { if (!e.relatedTarget) hovered = null; }, { passive: true });

  function pick() {
    var list = rows();
    if (!list.length) return null;
    var a = D.activeElement, i;
    if (a && a !== D.body) { for (i = 0; i < list.length; i++) { if (inRow(list[i], a)) return list[i]; } }
    if (hovered && D.contains(hovered)) {
      for (i = 0; i < list.length; i++) { if (inRow(list[i], hovered) && onScreen(list[i]) > 60) return list[i]; }
    }
    var top = null, most = 120;
    for (i = 0; i < list.length; i++) { var v = onScreen(list[i]); if (v > most) { most = v; top = list[i]; } }
    return top;
  }

  var last = 0;
  D.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    if (e.defaultPrevented || e.altKey || e.ctrlKey || e.metaKey || e.shiftKey || e.isComposing) return;
    if (typing(e.target) || blocked()) return;
    var row = pick();
    if (!row) return;
    e.preventDefault();
    /* a held key steps steadily instead of piling up scrolls */
    var now = Date.now();
    if (now - last < 180) return;
    last = now;
    var btn = e.key === 'ArrowLeft' ? row.prev : row.next;
    if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
    btn.click();
  });
})();
